<script>
  export let links = [];
  export let label = '';
</script>

<div>
  {#if links.length > 0}
    {#if label}
      <h5>{label}</h5>
    {/if}

    <ul>
      {#each links as item}
        {#if item?.clickFn}
          <!-- svelte-ignore a11y-click-events-have-key-events -->
          <li class="clickable" on:click={() => item.clickFn(item.slug)}>{item.name}</li>
        {:else}
          <li><a href={item.slug}>{item.name}</a></li>
        {/if}
      {/each}
    </ul>
  {/if}
</div>

<style>
  div {
    width: 100%;
  }

  h5 {
    font-weight: 700;
    color: #848484;
    font-size: 1.4rem;
    margin-bottom: 3rem;
  }

  ul {
    list-style: none;
  }

  li {
    margin-top: 1rem;
    color: #fff;
    font-size: 1.3rem;
  }

  a {
    text-decoration: none;
    color: #fff;
    font-size: 1.3rem;
  }

  a:hover {
    text-decoration: underline;
  }

  .clickable {
    cursor: pointer;
  }

  .clickable:hover {
    text-decoration: underline;
  }
</style>
